<div mat-dialog-title style="margin:0px;">
    <div>
        Student Address
    </div>
</div>

<mat-dialog-content>
    <table style="width:500px;">
        <tr>
            <td *ngIf="primaryAddress" style="color:gray;">
                Primary Address
            </td>
            <td *ngIf="mailingAddress" style="color:gray;">
                Mailing Address
            </td>
        </tr>
        <tr>
            <td *ngIf="primaryAddress">
                <div>
                    {{primaryAddress.HouseNumber}} {{primaryAddress.Direction}} {{primaryAddress.Street}} {{primaryAddress.StreetType}}
                </div>
                <div>
                    {{primaryAddress.City}}, {{primaryAddress.State}} {{primaryAddress.ZipCode}}
                </div>
            </td>
            <td *ngIf="mailingAddress">
                <div>
                    {{mailingAddress.HouseNumber}} {{mailingAddress.Direction}} {{mailingAddress.Street}} {{mailingAddress.StreetType}}
                </div>
                <div>
                    {{mailingAddress.City}}, {{mailingAddress.State}} {{mailingAddress.ZipCode}}
                </div>
            </td>
        </tr>
    </table>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button id="closeButton" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>
